import { combineReducers } from 'redux'

import { devicesReducer } from './components/devices/devices-reducer.js'
import { DEVICES_STATE_KEY_NAME } from './components/devices/constants.js'
import { dataSourcesReducer } from './components/devices/datasources/datasources-reducer.js'
import { DEVICE_DATA_SOURCES_KEY_NAME } from './components/devices/datasources/constants.js'

import { notificationsReducer } from './components/notifications/notifications-reducer.js'
import { NOTIFICATIONS_STATE_KEY_NAME } from './components/notifications/constants.js'

export const iotHubReducers = combineReducers({
  [DEVICES_STATE_KEY_NAME]: devicesReducer,
  [DEVICE_DATA_SOURCES_KEY_NAME]: dataSourcesReducer,
  [NOTIFICATIONS_STATE_KEY_NAME]: notificationsReducer,
})
